/* Numbers as an intensivist reads them. */

export const pct = (x: number | null | undefined, digits = 0): string => (x === null || x === undefined || !Number.isFinite(x) ? '—' : `${(x * 100).toFixed(digits)}%`)
export const fixed = (x: number | null | undefined, digits = 1): string => (x === null || x === undefined || !Number.isFinite(x) ? '—' : x.toFixed(digits))
export const int = (x: number | null | undefined): string => (x === null || x === undefined || !Number.isFinite(x) ? '—' : Math.round(x).toLocaleString('en-US'))
export const usd = (x: number | null | undefined): string => (x === null || x === undefined || !Number.isFinite(x) ? '—' : x >= 10000 ? `$${(x / 1000).toFixed(x >= 100000 ? 0 : 1)}k` : `$${Math.round(x).toLocaleString('en-US')}`)
/** A point value: the minus sign when negative, nothing else, and zero as "0". */
export const plain = (x: number, digits = 3): string => {
  const v = Number(x.toFixed(digits))
  return v === 0 ? '0' : `${v < 0 ? '−' : ''}${Math.abs(v).toFixed(digits)}`
}
/** A signed difference: a plus or the minus sign, and zero as "0" (never a plus-or-minus; a point value has no sign at all). */
export const signed = (x: number, digits = 3): string => {
  const v = Number(x.toFixed(digits))
  return v === 0 ? '0' : `${v > 0 ? '+' : '−'}${Math.abs(v).toFixed(digits)}`
}

/** Minutes of world time as "3 h 20 min" (or "2 d 4 h" for long stays). */
export function duration(min: number | null | undefined): string {
  if (min === null || min === undefined || !Number.isFinite(min)) return '—'
  const m = Math.round(min)
  if (Math.abs(m) < 60) return `${m} min`
  const h = Math.floor(Math.abs(m) / 60)
  const sign = m < 0 ? '−' : ''
  if (h < 48) return `${sign}${h} h${Math.abs(m) % 60 ? ` ${Math.abs(m) % 60} min` : ''}`
  return `${sign}${Math.floor(h / 24)} d ${h % 24} h`
}

/** World minute t as "T+3:20" (hours:minutes since the bed was taken). */
export function tplus(t: number): string {
  const m = Math.max(0, Math.round(t))
  return `T+${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`
}

export const hours = (t: number): string => `${(t / 60).toFixed(t < 600 ? 1 : 0)} h`

export function relativeTime(iso: string, now = Date.now()): string {
  const s = Math.round((now - Date.parse(iso)) / 1000)
  if (!Number.isFinite(s)) return iso
  if (s < 60) return 'just now'
  if (s < 3600) return `${Math.floor(s / 60)} min ago`
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
}

export const shortHash = (h: string, n = 10): string => h.slice(0, n)
